import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-8 px-4 bg-brand-bg" data-id="element-64">
      <div className="max-w-2xl mx-auto" data-id="element-65">
        <div className="bg-white border-2 border-brand-primary rounded-lg p-6 text-center" data-id="element-66">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-primary/10 rounded-full mb-4" data-id="element-67">
            <ShieldCheckIcon className="w-8 h-8 text-brand-primary" data-id="element-68" />
          </div>

          <h3 className="text-xl font-heading font-bold text-brand-primary mb-4" data-id="element-69">
            🛡️ GARANZIA TOTALE: RISCHIO ZERO PER 14 GIORNI
          </h3>

          <p className="text-sm sm:text-base text-brand-text mb-4 leading-relaxed" data-id="element-70">
            <strong data-id="element-71">Recupera la tua energia o ti rimborsiamo.</strong> Siamo
            così sicuri dell'efficacia di "Tiroide Felice" che ti diamo 14
            giorni interi per mettere alla prova le nostre ricette e i nostri
            protocolli. Se non senti che il tuo gonfiore addominale è diminuito,
            se non vedi la tua pelle più luminosa o se senti che il tuo livello
            di energia non è migliorato drasticamente... ti restituiamo ogni
            centesimo.
          </p>

          <div className="space-y-2 text-sm text-brand-text" data-id="element-72">
            <p data-id="element-73">
              <strong data-id="element-74">Rimborso integrale:</strong> Senza trattenute.
            </p>
            <p data-id="element-75">
              <strong data-id="element-76">Senza domande:</strong> Basta una mail a
              kitonline27@gmail.com.
            </p>
            <p data-id="element-77">
              <strong data-id="element-78">Procedura semplice:</strong> Ricevi il rimborso entro
              24/48 ore.
            </p>
          </div>
        </div>
      </div>
    </section>;
}